import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import type { SelectFilterLabels } from "@outpave/ds";

/** The strings a SelectFilter renders itself. English defaults, so translate them. */
export function useSelectFilterLabels(): SelectFilterLabels {
  const { t } = useTranslation();
  return useMemo(
    () => ({
      search: (label) =>
        t("SelectFilterSearch", { label: label.toLowerCase() }),
      noMatches: (label, query) =>
        t("SelectFilterNoMatches", { label: label.toLowerCase(), query }),
      available: (total) => t("SelectFilterAvailable", { total }),
    }),
    [t],
  );
}
